<template><section><h3>主题</h3>
<p>Qcharts 几乎所有的样式都在一个独立的配置文件中，通过修改这个配置文件，可以让 Qcharts 进行全局换肤，修改方式如下：</p>
<pre v-pre><code v-pre class="language-js"><span class="hljs-keyword">const</span> { theme } = qcharts
theme.set({
  <span class="hljs-attr">colors</span>: [<span class="hljs-string">'#71dac7'</span>, <span class="hljs-string">'#d57a77'</span>],
  <span class="hljs-attr">visuals</span>: {
    <span class="hljs-attr">Line</span>: {
      <span class="hljs-comment">//折线图</span>
      <span class="hljs-attr">styles</span>: {
        <span class="hljs-attr">point</span>: { <span class="hljs-attr">pointType</span>: <span class="hljs-string">'star'</span> }
      },
      <span class="hljs-attr">sttrs</span>: {}
    },
    <span class="hljs-attr">Area</span>: {
      <span class="hljs-comment">//面积图</span>
      <span class="hljs-attr">styles</span>: {},
      <span class="hljs-attr">sttrs</span>: {}
    },
    <span class="hljs-attr">Bar</span>: {
      <span class="hljs-comment">//柱状图</span>
      <span class="hljs-attr">styles</span>: {},
      <span class="hljs-attr">sttrs</span>: {}
    }
    <span class="hljs-comment">//...</span>
  },
  <span class="hljs-attr">plugins</span>: {
    <span class="hljs-comment">// 富矿提示</span>
    <span class="hljs-attr">Tooltip</span>: {
      <span class="hljs-attr">styles</span>: {},
      <span class="hljs-attr">attrs</span>: {}
    },
    <span class="hljs-comment">// 坐标轴</span>
    <span class="hljs-attr">Axis</span>: {
      <span class="hljs-attr">styles</span>: {},
      <span class="hljs-attr">attrs</span>: {}
    }
    <span class="hljs-comment">//...</span>
  }
})
</code></pre>
<p>通过 <code v-pre>qcharts.theme</code> 可以获取到默认的全局 theme 配置，方便对属性进行查看修改</p>
<img src="https://p0.ssl.qhimg.com/t018869aae1d36f086b.jpg" width="572">
<p>也可以单独设置某个组件的样式,单独通过 style 设置的优先级高于统一 theme 设置</p>
<pre v-pre><code v-pre class="language-js"><span class="hljs-keyword">const</span> line = <span class="hljs-keyword">new</span> Line()
line.style(<span class="hljs-string">'point'</span>, { <span class="hljs-attr">pointType</span>: <span class="hljs-string">'star'</span>, <span class="hljs-attr">angles</span>: <span class="hljs-number">5</span>, <span class="hljs-attr">innerRadius</span>: <span class="hljs-number">5</span>, <span class="hljs-attr">outerRadius</span>: <span class="hljs-number">10</span>, <span class="hljs-attr">strokeColor</span>: <span class="hljs-string">'#fff'</span> })
line.style(<span class="hljs-string">'point:hover'</span>, { <span class="hljs-attr">strokeColor</span>: <span class="hljs-string">'#f0f'</span> })
</code></pre>
</section></template><script>export default {components:{}}</script>